<template>
  <div class="pta-documents">
    <h1>Documents</h1>
    <div class="pta-content-center">
      <h2>Upload your marketing materials</h2>
      <ul class="pta-documents">
        <li><h3>Fact Sheet</h3></li>
        <li><h3>Presentation</h3></li>
        <li><h3>Team Bios</h3></li>
        <li><h3>Case Studies</h3></li>
        <li><h3>FAQ/DDQ</h3></li>
        <li><h3>Track Record</h3></li>
        <li><h3>Financial Model</h3></li>
        <li><h3>Key Terms</h3></li>
        <li><h3>Market Reports</h3></li>
        <li><h3>Any other marketing materials</h3></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){},
  methods: {},
  data() {
    return {}
  },
  computed: {
  },
  filters: {
  },
}
</script>